// filepath: d:\Code\Projects\TripleSData\UI-Dev2\dev\src\app\modules\globals\dash\modules\settings\components\venue-details\venue-details.component.ts
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { VenueDetailsService } from '../../services/venue-details.service';
import { ActivatedRoute } from '@angular/router';
import { NotifierService } from 'src/app/services/notifier.service';
import { APIService } from 'src/app/services/api.service';
import { getENV, getRaceType } from 'src/app/_helpers/helpers';

// Interface for HR Exporter Connector
interface HRExporterConnector {
  id?: string; // Optional ID for existing connectors
  type: 'TCPServer' | 'TCPClient' | 'UDPClient';
  protocol: 'MQTT' | 'DATA' | 'REQUESTS' | 'MONITOR' | 'CONTROL';
  hostname: string;
  port: number;
  enabled: boolean;
  groupId?: string; // Reference to the group this connector belongs to
  isNew?: boolean; // Flag to indicate a newly added connector
  isUpdated?: boolean; // Flag to indicate an updated connector
  isDeleted?: boolean; // Flag to indicate a deleted connector
}

// Interface for HR Exporter Connector Group
interface HRExporterConnectorGroup {
  id?: string; // Optional ID for existing groups
  name: string;
  description: string;
  connectors: HRExporterConnector[];
  isNew?: boolean; // Flag to indicate a newly added group
  isUpdated?: boolean; // Flag to indicate an updated group
  isDeleted?: boolean; // Flag to indicate a deleted group
}

// Interface for venue data
interface VenueData {
  type: string;
  venueName: string;
  connection_string: string;
  kit_name: string;
  venue_status: boolean;
  DefaultKit: string;
  DefaultTransceiverKit: string;
  external_venue_id: string;
  club_code: string;
  router_ip: string;
  timezone: string;
  trial: any;
  venue_abbr: string;
  deputy_abbr: string;
  venue_country: string;
  venue_state: string;
  jurisdiction: string;
  startlist_hours: number | null;
  MonitorAlias: string;
  ltsConnectors: any[];
  rtcmConnectors: any[];
  masteringConnectors: any[];
  DefaultConnectorGroup: string;
  connectors: HRExporterConnector[];
  connectorGroups: HRExporterConnectorGroup[];
  notes: string;
  CodeType: string;
}

declare var CKEDITOR: any;
@Component({
  selector: 'app-venue-details',
  templateUrl: './venue-details.component.html',
  styleUrls: ['./venue-details.component.css'],
})
export class VenueDetailsConfigComponent implements OnInit, AfterViewInit {
  venues: any[] = [];
  venueData: VenueData = {
    type: 'Harness Racing',
    venueName: '',
    connection_string: '',
    kit_name: 'DEFAULT',
    venue_status: true,
    DefaultKit: '',
    DefaultTransceiverKit: '',
    external_venue_id: '',
    club_code: '',
    router_ip: '',
    timezone: '',
    trial: null,
    venue_abbr: '',
    deputy_abbr: '',
    venue_country: 'Australia',
    venue_state: 'VIC',
    jurisdiction: '',
    startlist_hours: null,
    MonitorAlias: '',
    ltsConnectors: [],
    rtcmConnectors: [],
    masteringConnectors: [],
    DefaultConnectorGroup: 'DEFAULT',
    connectors: [],
    connectorGroups: [],
    notes: '',
    CodeType: '',
  };
  isEdit = false;
  showModal = false;

  config: any;
  editorInstance: any;
  filterStatus: string = 'enabled';
  newKitName: string = '';
  tagKits: string[] = [];
  transceiverKits: string[] = [];
  kits: string[] = [];
  times: { name: string; displayName: string }[] = [
    { name: 'Australia/Sydney', displayName: 'Australia/Sydney' },
    { name: 'Australia/Melbourne', displayName: 'Australia/Melbourne' },
    { name: 'Australia/Brisbane', displayName: 'Australia/Brisbane' },
    { name: 'Australia/Adelaide', displayName: 'Australia/Adelaide' },
    { name: 'Australia/Perth', displayName: 'Australia/Perth' }
  ];
  // Store API connector groups to populate dropdown
  apiConnectorGroups: HRExporterConnectorGroup[] = [];

  constructor(
    private venueDetailsService: VenueDetailsService,
    private activatedRoute: ActivatedRoute,
    private apiService: APIService,
    private notifier: NotifierService
  ) {
    this.config = this.activatedRoute.snapshot.data['config'];
  }
  ngOnInit() {
    this.loadVenues();
    this.loadJurisdictions(this.venueData.type);
    this.loadKits();
    this.loadTagKits();
    this.loadConnectorGroups();
    // Initialize arrays if undefined
    if (!this.venueData.connectors) {
      this.venueData.connectors = [];
    }
    if (!this.venueData.connectorGroups) {
      this.venueData.connectorGroups = [];
    }
  }

  ngAfterViewInit() {
    if (this.showModal) {
      this.initializeCKEditor();
    }
  }

  initializeCKEditor() {
    this.editorInstance = CKEDITOR.replace('venueNotesEditor', {
      contentsCss: ['https://cdn.ckeditor.com/4.16.0/full-all/contents.css'],
      fontSize_defaultLabel: '20px',
      removeButtons: 'Image,Iframe',
    });

    this.editorInstance.setData(this.venueData.notes || '');
  }

  async saveNotes() {
    this.venueData.notes = this.editorInstance.getData();
  }
  jurisdictions = [];
  types: string[] = [
    'Harness Racing',
    'Thoroughbred Racing',
    'Greyhound Racing',
  ];
  selectedJurisdiction: string = '';

  allVenues: any = [];
  selectRaceType(type: string) {
    this.venueData.type = type;
    // Set CodeType based on race type
    switch (type) {
      case 'Harness Racing':
        this.venueData.CodeType = 'HARNESS';
        break;
      case 'Thoroughbred Racing':
        this.venueData.CodeType = 'GALLOPS';
        break;
      case 'Greyhound Racing':
        this.venueData.CodeType = 'GREYHOUND';
        break;
    }
    this.loadJurisdictions(type);
    this.venues = this.allVenues.filter((venue: any) => {
      return venue.raceType == type;
    });
    this.applyFilter();
    // Load tag kits after updating CodeType
    this.loadTagKits();
  }

  getFullConnectionString(payload: boolean = false): string {
    if (payload) {
      return (
        'Server=.' +
        '\\' +
        `SQLEXPRESS;DataBase=HRTraCe_${this.venueData.connection_string}`
      );
    } else {
      return `Server=.\\SQLEXPRESS;DataBase=HRTraCe_${this.venueData.connection_string}`;
    }
  }

  async loadJurisdictions(type: string) {
    try {
      const response = await this.venueDetailsService.getJurisdictions(
        this.config,
        type
      );

      if (response.status == '1' || response.s == '1') {
        this.jurisdictions = response['response'];
      }

      if (this.jurisdictions.length > 0) {
        this.venueData.jurisdiction = this.jurisdictions[0];
      }
    } catch (error) {
      console.error('Error loading jurisdictions:', error);
    }
  }

  async loadVenues() {
    let result: any = await this.venueDetailsService.loadVenues(this.config);
    if (result.status == '1' || result.s == '1') {
      this.allVenues = result.venues
        .map((venue: any) => {
          return {
            ExternalVenueID: venue.ExternalVenueID,
            VenueName: venue.VenueName,
            Enabled: venue.Enabled,
            Notes: venue.Notes,
            ClubCode: venue.ClubCode,
            VenueAbbr: venue.VenueAbbr,
            VenueCountry: venue.VenueCountry,
            VenueState: venue.VenueState,
            Jurisdiction: venue.Jurisdiction,
            DefaultKit: venue.DefaultKit,
            CodeType: venue.CodeType,
            raceType: getRaceType(venue.ExternalVenueID)['raceTypeStr'],
          };
        })
        .sort((a, b) => a.VenueName.localeCompare(b.VenueName));
      this.applyFilter();
    }
  }

  applyFilter() {
    this.venues = this.allVenues.filter((venue: any) => {
      return (
        (this.filterStatus === 'all' ||
          (this.filterStatus === 'enabled' && venue.Enabled) ||
          (this.filterStatus === 'disabled' && !venue.Enabled)) &&
        venue.raceType == this.venueData.type
      );
    });
  }

  async onSubmit(action: string) {
    if (this.venueData['kit_name'] == 'new') {
      this.venueData['kit_name'] = this.newKitName;
    }

    // Ensure connectors exists
    if (!this.venueData.connectors) {
      this.venueData.connectors = [];
    }
    if (!this.venueData.connectorGroups) {
      this.venueData.connectorGroups = [];
    }

    // Check if any connector exists
    if (
      this.venueData.ltsConnectors.length === 0 &&
      this.venueData.rtcmConnectors.length === 0 &&
      this.venueData.masteringConnectors.length === 0 &&
      this.venueData.connectors.length === 0
    ) {
      this.notifier.alert(
        'Info',
        '',
        'At least one connector must be present.',
        'info',
        5000
      );
      return;
    }

    try {
      // Now process venue configuration with the selected connector group
      const payloadData = {
        ...this.venueData,
        connection_string: this.getFullConnectionString(true),
      };

      const payload = {
        action: 'venue_configuration',
        data: payloadData
      };

      const response = await this.venueDetailsService.venueConfiguration(
        this.config,
        payload.data
      );

      if (action === 'createVenue') {
        this.venues.push({ ...this.venueData });
      } else if (action === 'updateVenue') {
        const index = this.venues.findIndex(
          (v) => v.venueName === this.venueData.venueName
        );
        if (index !== -1) {
          this.venues[index] = { ...this.venueData };
        }
      }

      this.showModal = false;
      this.notifier.alert(
        'Success',
        '',
        `Venue ${action === 'createVenue' ? 'created' : 'updated'} successfully.`,
        'success',
        5000
      );
    } catch (error) {
      console.error('Error in venue configuration:', error);
      this.notifier.alert(
        'Error',
        '',
        `Failed to ${action === 'createVenue' ? 'create' : 'update'} venue. ${error.message || ''}`,
        'error',
        5000
      );
    }
  }

  // Method to add a new LTS Connector
  addLTSConnector() {
    this.venueData.ltsConnectors.push({
      connectionName: '',
      connectionType: '',
      ipAddress: '',
      port: null,
    });
  }

  // Method to remove an LTS Connector
  removeLTSConnector(index: number) {
    this.venueData.ltsConnectors.splice(index, 1);
  }

  // Method to add a new RTCM Connector
  addRTCMConnector() {
    this.venueData.rtcmConnectors.push({
      connectionName: '',
      connectionType: '',
      ipAddress: '',
      port: null,
    });
  }

  // Method to remove an RTCM Connector
  removeRTCMConnector(index: number) {
    this.venueData.rtcmConnectors.splice(index, 1);
  }

  // Method to add a new Mastering Connector
  addMasteringConnector() {
    this.venueData.masteringConnectors.push({
      connectorGroupID: '',
      ConnectorGroupName: '',
      connectionName: '',
      connectionType: '',
      ipAddress: '',
      port: null,
    });
  }

  // Method to remove a Mastering Connector
  removeMasteringConnector(index: number) {
    this.venueData.masteringConnectors.splice(index, 1);
  }

  // Method to open the modal for adding a new venue
  openAddVenueModal() {
    this.isEdit = false;
    const defaultType = 'Harness Racing';
    this.venueData = {
      type: defaultType,
      venueName: '',
      connection_string: '',
      router_ip: '',
      timezone: '',
      trial: null,
      kit_name: '',
      venue_status: true,
      external_venue_id: '',
      DefaultKit: '',
      DefaultTransceiverKit: '',
      club_code: '',
      venue_abbr: '',
      deputy_abbr: '',
      venue_country: 'Australia',
      venue_state: 'VIC',
      jurisdiction: '',
      startlist_hours: null,
      MonitorAlias: '',
      ltsConnectors: [],
      rtcmConnectors: [],
      masteringConnectors: [],
      DefaultConnectorGroup: '',
      connectors: [],
      connectorGroups: [],
      notes: '',
      CodeType: 'HARNESS',
    };
    this.loadJurisdictions(this.venueData.type);
    this.loadKits();
    this.loadConnectorGroups();
    this.showModal = true;
    setTimeout(() => {
      this.initializeCKEditor();
    });
  }

  addKit() {
    this.venueData['kit_name'] = 'new';
    this.venueData.ltsConnectors = [];
    this.venueData.rtcmConnectors = [];
    this.venueData.masteringConnectors = [];
  }

  cancelAddKit() {
    this.venueData['kit_name'] = this.venueData['DefaultTransceiverKit'] || this.venueData['DefaultKit'];
    if (this.venueData['kit_name']) {
      this.loadKitDetails();
    }
  }

  onKitChange() {
    // Update kit_name with selected DefaultTransceiverKit
    this.venueData.kit_name = this.venueData.DefaultTransceiverKit;

    // Load kit details when Default Transceiver Kit changes
    this.loadKitDetails();
  }

  // Load tag kits from a different API
  async loadTagKits() {
    try {
      const header = {
        'X-Api-Key': 'e2bvuAoslY1VJvFMqhr5x7nxoEhFVRii9jRngS3U',
      };

      let apiURL: string = `${
        this.config[getENV()].raceAPI
      }/devices/kit_names?jurisdiction=${
        encodeURIComponent(this.venueData.venue_state)
      }&code_type=${encodeURIComponent(this.venueData.CodeType)}`;

      let kit_result: any = await this.apiService.getDataPromis(apiURL, {}, header);

      this.tagKits = kit_result || [];

    } catch (error) {
      console.error('Error loading tag kits:', error);
      this.tagKits = [];
    }
  }

  async loadKitDetails() {
    try {
      let result = await this.venueDetailsService.getKitDetails(
        this.config,
        this.venueData['kit_name']
      );

      if (result.kits && result.kits.length > 0) {
        const kit = result.kits[0];
        this.venueData.ltsConnectors = kit.lts.map((connector: any) => ({
          connectionName: connector.connector_name,
          connectionType: connector.connector_type,
          ipAddress: connector.ip_address,
          port: connector.port,
        }));
        this.venueData.rtcmConnectors = kit.rtcm.map((connector: any) => ({
          connectionName: connector.connector_name,
          connectionType: connector.connector_type,
          ipAddress: connector.ip_address,
          port: connector.port,
        }));
        this.venueData.masteringConnectors = kit.master.map(
          (connector: any) => ({
            connectorGroupID: connector.connector_group_id,
            ConnectorGroupName: connector.connector_group_name,
            connectionName: connector.connector_name,
            connectionType: connector.connector_type,
            ipAddress: connector.ip_address,
            port: connector.port,
          })
        );
      }
    } catch (error) {}
  }

  async loadVenueDetails() {
    try {
      let response: any = await this.venueDetailsService.getLocationDetails(
        this.config,
        this.venueData['external_venue_id'],
        this.venueData['type'],
        this.venueData['venueName']
      );

      if (response && response.venues) {
        let connectionString = response.venues.connectionString.replace(
          'Server=.\\SQLEXPRESS;DataBase=HRTraCe_',
          ''
        );

        // Make a copy of existing venue data
        const existingData = { ...this.venueData };

        // Map connector groups and their connectors from the response
        let mappedConnectorGroups: HRExporterConnectorGroup[] = [];
        const responseConnectorGroups = response.venues.connectorGroups || [];

        // Process connector groups from the API response
        if (responseConnectorGroups.length > 0) {
          mappedConnectorGroups = responseConnectorGroups.map(group => ({
            id: group.id,
            name: group.name || '',
            description: group.description || '',
            connectors: (group.connectors || []).map(conn => ({
              id: conn.id,
              groupId: group.id,
              type: conn.type || 'TCPClient',
              protocol: conn.protocol || 'DATA',
              hostname: conn.hostname || '',
              port: conn.port || null,
              enabled: conn.enabled !== undefined ? conn.enabled : true
            }))
          }));
        }

        // Map standalone connectors from the response or use an empty array if none exist
        const responseConnectors = response.venues.connectors || [];
        const mappedConnectors: HRExporterConnector[] = responseConnectors.map(conn => ({
          id: conn.id,
          type: conn.type || 'TCPClient',
          protocol: conn.protocol || 'DATA',
          hostname: conn.hostname || '',
          port: conn.port || null,
          enabled: conn.enabled !== undefined ? conn.enabled : true
        }));

        this.venueData = {
          type: existingData.type,
          DefaultKit: response.venues.DefaultKit,
          DefaultTransceiverKit: response.venues.DefaultTransceiverKit || '',
          venueName: response.venues.VenueName,
          connection_string: connectionString,
          kit_name: response.venues.DefaultTransceiverKit || response.venues.DefaultKit,
          venue_status: response.venues.Enabled,
          external_venue_id: existingData.external_venue_id,
          club_code: response.venues.ClubCode,
          venue_abbr: response.venues.VenueAbbr,
          deputy_abbr: response.venues.DeputyAbbr,
          venue_country: response.venues.VenueCountry,
          router_ip: response.venues.RouterIP,
          timezone: response.venues.TimeZone,
          trial: response.venues.Trial,
          venue_state: response.venues.VenueState,
          jurisdiction: response.venues.Jurisdiction,
          startlist_hours: response.venues.startlist_hours ? parseInt(response.venues.startlist_hours, 10) : null,
          ltsConnectors: existingData.ltsConnectors,
          rtcmConnectors: existingData.rtcmConnectors,
          masteringConnectors: existingData.masteringConnectors,
          DefaultConnectorGroup: response.venues.DefaultConnectorGroupId,
          connectors: mappedConnectors,
          connectorGroups: mappedConnectorGroups,
          notes: response.venues.Notes,
          CodeType: response.venues.CodeType || existingData.CodeType,
          MonitorAlias: existingData.MonitorAlias,
        };

        console.log('Loaded venue data:', this.venueData, this.apiConnectorGroups.length);

        if (response.venues.DefaultConnectorGroupId && this.apiConnectorGroups.length > 0) {
          this.onDefaultConnectorGroupChange();
        }

        // After updating venue data, load the tag kits
        await this.loadTagKits();
      }
    } catch (error) {
      console.log('FAILED TO LOAD VENUE: ', error);
      // Initialize arrays if something goes wrong
      if (!this.venueData.connectors) {
        this.venueData.connectors = [];
      }
      if (!this.venueData.connectorGroups) {
        this.venueData.connectorGroups = [];
      }
    }
  }

  async loadKits() {
    try {
      // Load kits for transceiver kit dropdown from current API
      let response: any = await this.venueDetailsService.getKits(
        this.config,
        this.venueData['external_venue_id']
      );

      // Store all kits for transceiver dropdown
      this.kits = response.kits;
      this.transceiverKits = response.kits || [];

      // Set default kit if not already set
      if (!this.venueData['kit_name']) {
        this.venueData['kit_name'] = this.kits[0];
      }

      // Load tag kits from different API
      await this.loadTagKits();

      // Load kit details if DefaultTransceiverKit is selected
      if (this.venueData.DefaultTransceiverKit && this.venueData.DefaultTransceiverKit !== 'new') {
        this.venueData.kit_name = this.venueData.DefaultTransceiverKit;
        await this.loadKitDetails();
      }
    } catch (error) {
      console.error('Error loading kits:', error);
    }
  }

  timezoneList = [
    {
      country: 'Australia',
      city: 'Sydney, Melbourne, Canberra',
      timeZone: 'Australia/Sydney',
      currentTime: new Date().toLocaleString('en-US', {
        timeZone: 'Australia/Sydney',
      }),
      name: 'AUS Eastern Standard Time',
      id: 'AUS Eastern Standard Time',
      diff: 'UTC +10:00',
      displayName: '(UTC+10:00) Canberra, Melbourne, Sydney'
    },
    // ... other timezones
  ];

  // Method to open the modal for editing an existing venue
  openEditVenueModal(venue) {
    this.isEdit = true;
    const raceType: string = getRaceType(venue.ExternalVenueID)['raceTypeStr'];

    // Determine CodeType based on race type
    let codeType = '';
    switch (raceType) {
      case 'Harness Racing':
        codeType = 'HARNESS';
        break;
      case 'Thoroughbred Racing':
        codeType = 'GALLOPS';
        break;
      case 'Greyhound Racing':
        codeType = 'GREYHOUND';
        break;
    }

    // Initialize venue data with proper defaults and existing values
    this.venueData = {
      type: raceType,
      venueName: venue.VenueName,
      connection_string: '',
      DefaultKit: venue.DefaultKit || 'DEFAULT',
      DefaultTransceiverKit: venue.DefaultTransceiverKit || '',
      kit_name: venue.DefaultTransceiverKit || venue.DefaultKit || 'DEFAULT',
      venue_status: venue.Enabled,
      external_venue_id: venue.ExternalVenueID,
      club_code: venue.ClubCode || '',
      venue_abbr: venue.VenueAbbr || '',
      deputy_abbr: venue.DeputyAbbr || '',
      venue_country: venue.VenueCountry || 'Australia',
      venue_state: venue.VenueState || 'VIC',
      jurisdiction: venue.Jurisdiction || '',
      startlist_hours: null,
      router_ip: '',
      timezone: '',
      trial: null,
      MonitorAlias: '',
      ltsConnectors: [],
      rtcmConnectors: [],
      masteringConnectors: [],
      DefaultConnectorGroup: '',
      connectors: [],
      connectorGroups: [],
      notes: venue.Notes || '',
      CodeType: codeType
    };

    let promises: any = [];
    promises.push(this.loadJurisdictions(this.venueData.type));
    promises.push(this.loadConnectorGroups());
    promises.push(this.loadVenueDetails());
    promises.push(this.loadKits());
    this.showModal = true;
    Promise.all(promises).then((values: any) => {
      setTimeout(() => {
        this.initializeCKEditor();
      });
    });
  }

  // Get the name of the currently selected connector group
  getSelectedGroupName(): string {
    if (!this.venueData.DefaultConnectorGroup || !this.apiConnectorGroups.length) {
      return '';
    }

    const selectedGroup = this.apiConnectorGroups.find(
      group => group.id === this.venueData.DefaultConnectorGroup
    );

    return selectedGroup ? selectedGroup.name : '';
  }

  // Load connector groups from API
  async loadConnectorGroups() {
    try {
      this.notifier.alert(
        'Loading',
        '',
        'Loading connector groups...',
        'info',
        2000
      );

      const response: any = await this.venueDetailsService.getConnectorGroups(this.config);

      if (response && response.status === '1') {
        // Map the API response to our interface format
        this.apiConnectorGroups = (response.data || []).map((group: any) => ({
          id: group.Id,
          name: group.Name || '',
          description: group.Description || '',
          connectors: [],
          isNew: false,
          isUpdated: false,
          isDeleted: false
        }));

        // Sort groups alphabetically by name
        this.apiConnectorGroups.sort((a, b) => a.name.localeCompare(b.name));

        // Load connectors for each group
        await this.loadConnectorsForGroups();

        // Verify we have valid data
        if (this.apiConnectorGroups.length === 0) {
          this.notifier.alert(
            'Info',
            '',
            'No connector groups found',
            'info',
            3000
          );
        }
      } else {
        console.error('Failed to load connector groups:', response);
        this.notifier.alert(
          'Error',
          '',
          'Failed to load connector groups',
          'error',
          3000
        );
        this.apiConnectorGroups = [];
      }
    } catch (error) {
      console.error('Error loading connector groups:', error);
      this.notifier.alert(
        'Error',
        '',
        'Error loading connector groups',
        'error',
        3000
      );
      this.apiConnectorGroups = [];
    }
  }

  // Load connectors for all groups
  async loadConnectorsForGroups() {
    try {
      const response: any = await this.venueDetailsService.getConnectors(this.config, this.venueData.DefaultConnectorGroup);

      if (response && response.status === '1') {
        const connectors = response.data || [];

        // Reset connectors in all groups before assigning
        this.apiConnectorGroups.forEach(group => {
          group.connectors = [];
        });

        // Distribute connectors to their respective groups
        for (const connector of connectors) {
          const groupId = connector.ConnectorGroupId;
          if (groupId) {
            // Find the group this connector belongs to
            const group = this.apiConnectorGroups.find(g => g.id === groupId);
            if (group) {
              // Add connector to the group
              group.connectors.push({
                id: connector.Id,
                groupId: groupId,
                type: connector.Type || 'TCPClient',
                protocol: connector.Protocol || 'DATA',
                hostname: connector.Hostname || '',
                port: connector.Port ? parseInt(connector.Port, 10) : null,
                enabled: connector.Enabled !== undefined ? connector.Enabled : true
              });
            }
          }
        }

        // If the current group is selected, update its connectors
        if (this.venueData.DefaultConnectorGroup) {
          const selectedGroup = this.apiConnectorGroups.find(
            group => group.id === this.venueData.DefaultConnectorGroup
          );
          if (selectedGroup) {
            this.venueData.connectors = selectedGroup.connectors.map(conn => ({
              ...conn,
              isNew: false,
              isUpdated: false,
              isDeleted: false
            }));
          }
        }
      } else {
        console.error('Failed to load connectors:', response);
      }
    } catch (error) {
      console.error('Error loading connectors:', error);
    }
  }

  // Load connectors for the selected connector group and refresh from API
  async onDefaultConnectorGroupChange() {
    // First clear existing connectors and show loading indicator
    this.venueData.connectors = [];
    this.notifier.alert(
      'Loading',
      '',
      'Loading connectors for selected group...',
      'info',
      2000
    );

    try {
      // If a group is selected, fetch connectors from API
      if (this.venueData.DefaultConnectorGroup) {
        // Get fresh data from API for the specific group
        const response: any = await this.venueDetailsService.getConnectors(
          this.config,
          this.venueData.DefaultConnectorGroup
        );

        if (response && response.status === '1') {
          const groupConnectors = response.data || [];

          // Map API connector format to our format
          this.venueData.connectors = groupConnectors.map((connector: any) => ({
            id: connector.Id,
            groupId: connector.ConnectorGroupId,
            type: connector.Type || 'TCPClient',
            protocol: connector.Protocol || 'DATA',
            hostname: connector.Hostname || '',
            port: connector.Port ? parseInt(connector.Port, 10) : null,
            enabled: connector.Enabled !== undefined ? connector.Enabled : true,
            isNew: false,
            isUpdated: false,
            isDeleted: false
          }));

          // Show success message if connectors were found
          if (this.venueData.connectors.length > 0) {
            this.notifier.alert(
              'Success',
              '',
              `Loaded ${this.venueData.connectors.length} connectors for the selected group`,
              'success',
              2000
            );
          } else {
            this.notifier.alert(
              'Info',
              '',
              'No connectors found for the selected group',
              'info',
              3000
            );
          }
        } else {
          console.error('Failed to load connectors:', response);
          this.notifier.alert(
            'Error',
            '',
            'Failed to load connectors for the selected group',
            'error',
            3000
          );
        }
      }
    } catch (error) {
      console.error('Error loading connectors for group:', error);
      this.notifier.alert(
        'Error',
        '',
        'Error loading connectors for the selected group',
        'error',
        3000
      );
    }
  }

  // Refresh connectors for the currently selected group without changing selection
  async refreshConnectors(): Promise<void> {
    if (!this.venueData.DefaultConnectorGroup) {
      this.notifier.alert(
        'Info',
        '',
        'Please select a connector group first',
        'info',
        3000
      );
      return;
    }

    // Just call the change handler to reload connectors
    await this.onDefaultConnectorGroupChange();
  }
}
